import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  floorWithNS: [],
  roles: [],
  shifts: [],
  allFilters: {}
};

const userFilterDataSlice = createSlice({
  name: "userFilterData",
  initialState,
  reducers: {
    setFloorWithNS(state, action) {


      state.floorWithNS = action.payload;
    },
    setRoles(state, action) {
      const formattedRoles = (action.payload || []).map(role => {
        const formattedTitle = role
          .replace(/_/g, ' ')
          .replace(/\b\w/g, char => char.toUpperCase());

        return {
          value: role,
          title: formattedTitle
        };
      });
      state.roles = formattedRoles;
    },
    setShifts(state, action) {


      state.shifts = action.payload;
    },
    setAllFilters(state, action) {
      state.allFilters = action.payload;
    },
  },
});

export const { setFloorWithNS, setRoles, setShifts, setAllFilters } = userFilterDataSlice.actions;
export default userFilterDataSlice.reducer;